<template>
	<div class>
		<!-- Modal Component -->
		<b-modal hide-header hide-footer id="modal-add-platform" ref="modalAddPlatform"
			:modal-class="['modal-left', 'add-platform', { 'modal-collapsed': stage >= 1 }]">
			<div class="modal-container">
				<b-row align-v="start" class="px-3 mb-2">
					<b-col cols="8" class="mt-3">
						<h3 class="add-platform-title mt-2 mb-4">
							New Publish Platform
						</h3>
					</b-col>
					<b-col cols="4" class="mt-3 text-right">
						<form-button type="link" isIcon @click="dismiss"> 
							<icon-base>
								<icon-close />
							</icon-base>
						</form-button>
					</b-col>
				</b-row>
				<b-row align-v="start" class="px-3">
					<!-- Case total destination -->
					<b-col cols="12" class="">
						<b-alert show variant="secondary" class="d-flex p-2 mb-3"
							v-if="platformUsage && platformUsage.totalDestination">
							<svg data-v-3503005c="" width="14" height="15" viewBox="0 0 14 15" fill="none"
								xmlns="http://www.w3.org/2000/svg" class="text-dark-9 mr-2 mt-1 flex-shrink-0">
								<path data-v-3503005c="" fill-rule="evenodd" clip-rule="evenodd"
									d="M14 7.5C14 11.366 10.866 14.5 7 14.5C3.13401 14.5 0 11.366 0 7.5C0 3.63401 3.13401 0.5 7 0.5C10.866 0.5 14 3.63401 14 7.5ZM8 4.5C8 5.05228 7.55228 5.5 7 5.5C6.44772 5.5 6 5.05228 6 4.5C6 3.94772 6.44772 3.5 7 3.5C7.55228 3.5 8 3.94772 8 4.5ZM7.75 8C7.75 7.58579 7.41421 7.25 7 7.25C6.58579 7.25 6.25 7.58579 6.25 8V11C6.25 11.4142 6.58579 11.75 7 11.75C7.41421 11.75 7.75 11.4142 7.75 11V8Z"
									fill="currentColor"></path>
							</svg>
							<div>
								<div class="text-dark-9 text-s-m text-500 m-0">You have used {{ platformUsage.usedDestination }}/{{
									platformUsage.totalDestination }} destinations.</div>
								<div class="text-dark-7 text-s-s font-weight-normal m-0">Need more? <a class="text-underline text-dark-8"
										target="_blank" href="/app/subscribe">Upgrade</a> here.</div>
							</div>
						</b-alert>
					</b-col>
					<!-- Case unique/extra destination -->
					<b-col cols="12" class="">
						<b-alert show variant="secondary" class="d-flex p-2 mb-3"
							v-if="platformUsage && platformUsage.uniqueDestination && platformUsage.uniqueDestination.limit">
							<svg data-v-3503005c="" width="14" height="15" viewBox="0 0 14 15" fill="none"
								xmlns="http://www.w3.org/2000/svg" class="text-dark-9 mr-2 mt-1 flex-shrink-0">
								<path data-v-3503005c="" fill-rule="evenodd" clip-rule="evenodd"
									d="M14 7.5C14 11.366 10.866 14.5 7 14.5C3.13401 14.5 0 11.366 0 7.5C0 3.63401 3.13401 0.5 7 0.5C10.866 0.5 14 3.63401 14 7.5ZM8 4.5C8 5.05228 7.55228 5.5 7 5.5C6.44772 5.5 6 5.05228 6 4.5C6 3.94772 6.44772 3.5 7 3.5C7.55228 3.5 8 3.94772 8 4.5ZM7.75 8C7.75 7.58579 7.41421 7.25 7 7.25C6.58579 7.25 6.25 7.58579 6.25 8V11C6.25 11.4142 6.58579 11.75 7 11.75C7.41421 11.75 7.75 11.4142 7.75 11V8Z"
									fill="currentColor"></path>
							</svg>
							<div>
								<div class="text-dark-9 text-s-m text-500 m-0">You have used {{ platformUsage.uniqueDestination.used }}/{{
									platformUsage.uniqueDestination.limit }} unique destinations and {{
		platformUsage.extraDestination.used }}/{{ platformUsage.extraDestination.limit }} extra ones<span
										v-if="getStreamtype()"> across all {{ getStreamtype() }}</span>.</div>
								<div class="text-dark-7 text-s-s font-weight-normal m-0">Need more? <a class="text-underline text-dark-8"
										target="_blank" href="/app/subscribe">Upgrade</a> here.</div>
							</div>
						</b-alert>
					</b-col>
				</b-row>
				<b-row v-if="platformListProcessing">
					<Spinner text="Retrieving data..." classes="text-dark-8 my-3" spinner-color="var(--c-dark-8)"
						spinner-size="15px" />
				</b-row>
				<b-row v-if="!platformListProcessing" tag="ul" class="platform-list list-unstyled mx-0">
					<b-col class="mb-4" cols="6" md="4" tag="li">
						<div :class="{ active: customPlatform }" class="platform-item p-2" @click="selectPlatform()">
							<div class="platform-icon">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
										stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
									<path
										d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15V15Z"
										stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
							</div>
							<div class="platform-label">
								Custom
							</div>
						</div>
					</b-col>
					<b-col cols="6" md="4" tag="li" v-for="(plat, index) in platformTemplates" :key="index" class="mb-4"
						@click="selectPlatform(plat)">
						<div v-if="plat.name !== 'youtube'" class="platform-item p-2"
							:class="{ active: plat.name === platform.name }">
							<div class="platform-icon">
								<img width="100" class="mx-auto" :src="plat.icon">
							</div>
							<div class="platform-label">
								{{ plat.name === 'twitter' ? 'X (Twitter)' : plat.name }}
							</div>
						</div>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<div v-if="stream.type === 'unavail'">
							<hr class="divider">
							<p class="text-center font-weight-normal text-s-md mt-4">Want to stream to your website too?</p>
							<p class="text-center font-weight-normal text-s-md">Check out our <a class="link-main font-weight-bolder"
									href="#">Demo</a> for All-in-one product!</p>
						</div>
					</b-col>
				</b-row>
			</div>
			<section class="second-modal" :class="{ showform: stage >= 1 }">
				<b-row>
					<b-col>
						<h3 v-if="customPlatform" class="platform-name text-center py-4 mb-0 text-s-xl bg-dark-3 text-uppercase">
							Custom Platform</h3>
						<div v-else class="py-4 mb-0 text-s-xl bg-dark-3 text-center"> <img class="platform-icon_secondary mx-auto"
								width="100" :src="platform.icon"></div>
					</b-col>
				</b-row>
				<b-row class="px-4">
					<b-col>
						<b-alert v-if="error" show variant="danger-style2" class="mt-3">
							<div>{{ error.message }}</div>
							<div v-if="error.subscription" class="text-center">
								<a href="/app/subscribe">
									<button class="btn btn-sm btn-link">
										<strong>upgrade now</strong>
									</button>
								</a>
							</div>
						</b-alert>
					</b-col>
				</b-row>
				<b-row class="px-4 mt-4">
					<b-col>
						<div v-if="!configRequired" class="text-center">
							<div v-if="serviceLinkProcessing">
								<p v-if="serviceLinkError && serviceLinkConflict">
									This <span class="text-capitalize">{{ platform.name }}</span> account is already linked with the stream
								</p>
								<p v-else-if="serviceLinkError">
									sorry, couldn't link with specified <span class="text-capitalize">{{ platform.name }}</span> account
								</p>
								<p v-else>
									<span v-if="linkedServiceCreds"><span class="text-capitalize">{{ platform.name }}</span> connected, saving platform ..</span>
									<span v-else>Connecting to <span class="text-capitalize">{{ platform.name }}</span></span>
									&nbsp;
									<i class="fas fa-spinner fa-spin" />
								</p>
								<form-button type="secondary" v-if="!linkedServiceCreds || serviceLinkError" @click="cancelServiceLinking"> 
									Cancel
								</form-button>
							</div>
							<div v-else>
								<div>
									<p class="text-s-m text-dark-8 mb-2">I would connect to my <span class="text-capitalize">{{ platform.name
									}}</span> account</p>
									<p v-if="isServiceAlreadyLinked()" class="text-danger mb-2">
										<span class="text-capitalize">{{ platform.name }}</span> is already linked for this stream
									</p>
									<a v-else target="_blank" @click="getServiceOAuthUrl()">
										<form-button class="w-full justify-center" :disabled="isSchedulerInfiniteLoop" v-if="platform.name === 'facebook live'" @click="onServiceAuthURLTap"> 
											Continue With Facebook
										</form-button>
										<form-button class="w-full justify-center" :disabled="isSchedulerInfiniteLoop"  v-else @click="onServiceAuthURLTap"> 
											Connect
											to <span class="text-capitalize">{{ platform.slug || platform.name }}</span>
										</form-button>
									</a>
									<p class="text-s-s text-dark-6" v-if="isSchedulerInfiniteLoop">Due to Facebook restriction, Infinite
										Loop mode cannot be used with option.</p>
								</div>
								<div class="text-dark-8 mt-2 mb-4 lined">
									<span class="searator-text">or</span>
								</div>
								<div>
									<p class="text-dark-8 text-s-m mb-2">I would provide server and stream key</p>
									<form-button class="w-full justify-center" :disabled="isBroadcastSubscription && platform.name === 'facebook live'" @click="ignoreServiceLinking"> 
										Setup with Server/Key
									</form-button>
									<div v-if="isBroadcastSubscription && platform.name === 'facebook live'">
										Use custom RTMP to add Facebook Page/Group or Upgrade to use this feature
									</div>
								</div>

								<div class="mt-3">
									<form-button class="w-full justify-center" type="secondary" @click="unselectPlatform"> 
										Cancel
									</form-button>
								</div>
								<div class="doc mt-2">
									<a class="text-s-s text-dark-6 inline-flex items-center" target="_blank"
										href="http://docs.castr.com/en/articles/2291793-how-to-connect-facebook-live-with-castr"
										v-if="platform.name === 'facebook live'"><img src="@/assets/images/book.png" class="mr-2" alt="Doc"> How to connect
										Facebook to Castr</a>
									<a class="text-s-s text-dark-6 inline-flex items-center" target="_blank"
										href="https://docs.castr.com/en/articles/5369538-how-to-connect-youtube-with-castr"
										v-if="platform.name === 'youtube events'"><img src="@/assets/images/book.png" class="mr-2" alt="Doc"> How to
										connect YouTube to Castr</a>
								</div>
							</div>
						</div>
						<div v-else>
							<b-row v-if="customPlatform" class="field-container mt-4">
								<b-col class="px-3 px-md-3 py-2">
									<div class="custom-platform-type">
										<ul class="d-flex align-items-center justify-content-between text-center mb-0">
											<li class="text-dark-9 text-s-m" :class="customMode === 'RTMP' ? 'active' : ''"
												@click="onCustomModeChanged('RTMP')">RTMP</li>
											<li class="text-dark-9 text-s-m" :class="customMode === 'SRT' ? 'active' : ''"
												@click="onCustomModeChanged('SRT')">SRT</li>
										</ul>
									</div>
								</b-col>
							</b-row>

							<div v-if="customPlatform && customMode === 'SRT'" class="field-container mt-4">
								<!-- host -->
								<FormInput label="Host" v-model="customSrtPlatform.host"  placeholder="srt-ingest.example.com" class="mb-2" @keypress="onInputChange('host')" @keyup="onInputChange('host')"  :isError="isError('host')" :helper="errorText('host')"/>
								<!-- port -->
								<FormInput label="Port" v-model="customSrtPlatform.port"  placeholder="9998" class="mb-2" @keydown="onInputChange('port')" @keyup="onInputChange('port')" :isError="isError('port')" :helper="errorText('port')"/>

								<!-- stream id -->
								<FormInput label="Stream Id" v-model="customSrtPlatform.streamId"  placeholder="stream id" class="mb-2" @keypress="onInputChange('streamId')" @keyup="onInputChange('streamId')" :isError="isError('streamId')" :helper="errorText('streamId')"/>
								<!-- latency -->
								<FormInput label="Latency" v-model="customSrtPlatform.latency"  placeholder="120" class="mb-2" @keypress="onInputChange('latency')" @keyup="onInputChange('streamId')" :isError="isError('latency')" :helper="errorText('latency')"/>
								<FormInput label="Passphrase" v-model="customSrtPlatform.passphrase"  placeholder="Passphrase" class="mb-2" @keypress="onInputChange('passphrase')" @keyup="onInputChange('passphrase')" :isError="isError('passphrase')" :helper="errorText('passphrase')"/>
							</div>

							<div v-else-if="shouldConfigureServer()" class="field-container mt-4">
								<p v-show="formErrors.server" class="text-danger">
									<!-- specify {{ customPlatform && 'destination' || platform.name }} server -->
									invalid {{ customPlatform && 'destination' || platform.name }} ingest address
								</p>
								<label>
									streaming {{ customPlatform && 'platform address' || 'server' }}
								</label>

								<!-- <input v-if="customPlatform || platform.customServer" -->
								<div v-if="checkServerInputMode('input')">
									<FormInput v-model="platform.server" :placeholder="platform.serverInputPlaceholder || 'rtmp://broadcaster_addr/'" class="mb-2" @keypress="onInputChange('server')" @keyup="onInputChange('server')" :isError="isError('server')" :helper="errorText('server')"/>
									<div v-if="customPlatform">
										<p v-show="customSrtPlatformErrors.server && !formErrors.server" class="text-danger">
											{{ customSrtPlatformErrors.server }}
										</p>
										<b-form-checkbox class="mb-2" v-model="isAuthRequired">Authentication Required
										</b-form-checkbox>
										<div v-if="isAuthRequired">
											<FormInput v-model="rtmpAuthUsername" placeholder="Username" class="mb-2" />
											<FormInput v-model="rtmpAuthPassword" type="password" placeholder="Password" class="mb-2" @blur="checkPassword" :isError="!isRtmpPassValid" :helper="!isRtmpPassValid ? '@ symbol is not supported in password, please change the password.' : null" />
										</div>
									</div>
								</div>
								<div v-else-if="checkServerInputMode('chunks')" class="input-container" @click="focusServerKeySegment">
									<div v-for="(segment, index) in platform.serverKeySegments" :key="index">
										<FormInput v-if="segment.input" v-model="platform.serverKeySegmentValues[index]" :placeholder="segment.placeholder" class="mb-2" @change="computePlatformServerFromSegments" @keypress="onInputChange('server')" />
										<div v-else-if="!segment.hidden" class="value-placeholder">
											{{ segment.text || segment }}
										</div>
									</div>
								</div>
								<b-dropdown v-else-if="checkServerInputMode('select')" id="dropdown-1" variant="dark-3"
									class="region-dropdown w-100 mb-2" menu-class="dropdown-menu_md test w-100 mt-0" size="md" no-caret>
									<template #button-content>
										<div class="d-flex align-items-center w-100">
											<span class="font-weight-normal text-s-m" v-if="chosenServer">
												<span>{{ chosenServer }}</span>
											</span>
											<span class="text-dark-8 font-weight-normal text-s-m" v-else>Select one</span>
											<svg class="ml-auto flex-shrink-0" width="10" height="6" viewBox="0 0 10 6" fill="none"
												xmlns="http://www.w3.org/2000/svg">
												<path
													d="M8.26863 2.73137L6.13137 4.86863C5.73535 5.26465 5.53735 5.46265 5.30902 5.53684C5.10817 5.6021 4.89183 5.6021 4.69098 5.53684C4.46265 5.46265 4.26465 5.26465 3.86863 4.86863L1.73137 2.73137C0.874618 1.87462 0.446241 1.44624 0.417296 1.07846C0.392181 0.759341 0.521356 0.447486 0.764766 0.239594C1.04529 0 1.65111 0 2.86274 0L7.13726 0C8.34889 0 8.95471 0 9.23523 0.239594C9.47864 0.447486 9.60782 0.759341 9.5827 1.07846C9.55376 1.44624 9.12538 1.87462 8.26863 2.73137Z"
													fill="currentColor" />
											</svg>
										</div>
									</template>
									<b-dropdown-item-button :key="server.id" v-for="server in platform.servers"
										@click="selectServer(server)">{{ server.text }}
									</b-dropdown-item-button>
								</b-dropdown>
							</div>
							<p class="text-dark-7 text-size-m" v-if="linkedServiceCreds">
								Some ingest details captured from connected <span class="text-capitalize">{{ platform.name }}</span> account
							</p>
							<div v-else-if="customMode !== 'SRT'" class="field-container mt-4">
								<FormInput label="streaming key" v-model="platform.streamKey" :placeholder="platform.streamKeyPlaceholder || '#streaming_key'" class="mb-2" @keypress="onInputChange('streamKey')" @keyup="onInputChange('streamKey')" />
							</div>

							<!-- stream metadata form -->
							<div v-if="canConfigureMetadata()">
								<div
									v-if="platform.serviceAuthorization.subChannelRequired && !platform.serviceAuthorization.autoSelectDefaultSubChannel"
									class="field-container mt-4">
									<label>
										{{ platform.serviceAuthorization.subChannelFieldLabel || 'Publishing Channel' }}
									</label>

									<b-dropdown id="service-subchannels-dropdown" variant="dark-3" class="region-dropdown w-100 mb-2"
										menu-class="dropdown-menu_md test w-100 mt-0" size="md" no-caret @show="onSubchannelListToggle(true)"
										@hide="onSubchannelListToggle(false)">
										<template #button-content>
											<div class="d-flex align-items-center w-100">
												<span class="font-weight-normal text-s-m" v-if="selectedSubChannel">
													<span>{{ selectedSubChannel.name }}</span>
												</span>
												<span class="text-dark-8 font-weight-normal text-s-m" v-else>Select one</span>
												<svg class="ml-auto flex-shrink-0" width="10" height="6" viewBox="0 0 10 6" fill="none"
													xmlns="http://www.w3.org/2000/svg">
													<path
														d="M8.26863 2.73137L6.13137 4.86863C5.73535 5.26465 5.53735 5.46265 5.30902 5.53684C5.10817 5.6021 4.89183 5.6021 4.69098 5.53684C4.46265 5.46265 4.26465 5.26465 3.86863 4.86863L1.73137 2.73137C0.874618 1.87462 0.446241 1.44624 0.417296 1.07846C0.392181 0.759341 0.521356 0.447486 0.764766 0.239594C1.04529 0 1.65111 0 2.86274 0L7.13726 0C8.34889 0 8.95471 0 9.23523 0.239594C9.47864 0.447486 9.60782 0.759341 9.5827 1.07846C9.55376 1.44624 9.12538 1.87462 8.26863 2.73137Z"
														fill="currentColor" />
												</svg>
											</div>
										</template>
										<b-dropdown-item v-for="subchannel in platform.subChannelList" :key="subchannel.id"
											link-class="d-block" class="page-item" :class="{
												active: selectedSubChannel && subchannel.id === selectedSubChannel.id,
												disabled: isSubChannelDisabled(subchannel)
											}" @click="changeSubChannelSelection(subchannel)">
											<div class="main text-s-m text-dark-9 text-500">
												{{ subchannel.name }}
											</div>
											<div v-show="subchannel.type" class="desc text-s-s text-dark-6">
												<span v-show="platform.name === 'facebook live'">facebook</span> <span>{{ subchannel.type
												}}</span>
											</div>
											<div class="ml-1 hint-upgrade text-s-xs color-danger">
												Not available on Trial plan
											</div>
										</b-dropdown-item>
									</b-dropdown>
								</div>

								<!-- <div v-if="hasMetaProp('title')" class="field-container"> -->
								<div v-if="canConfigureMetadata('title') || platform.name === 'youtube events'"
									class="field-container mt-4">
									<FormInput :label="'Stream Title ' + (showTitleLimitTracking ? '(' + platform.configurableMetadata.title.length + '/100)' : '')" v-model="platform.configurableMetadata.title" :maxlength="maxLengthTitle" placeholder="Enter stream title" class="mb-2" />
								</div>

								<!-- <div v-if="hasMetaProp('description')" class="field-container"> -->
								<div v-if="canConfigureMetadata('description') || platform.name === 'youtube events'"
									class="field-container mt-4">
									<label for="">
										Stream Description {{ showTitleLimitTracking ? '(' + platform.configurableMetadata.description.length
											+
											'/5000)' : '' }}
									</label>

									<b-form-textarea class="mb-3" v-model="platform.configurableMetadata.description"
										:maxlength="maxLengthDescription" placeholder="Enter stream description" />

								</div>

								<div v-if="platform.name === 'youtube events'"
									class="field-container mt-4 mb-4">
									<label for="">
										Privacy Status
									</label>

									<drop-down-menu ref="youtubePrivacyDropdownInDialog" type="secondary" customClasses="w-full text-sm h-8 bg-surface-3 hover:bg-surface-4 rounded-md flex items-center px-3 capitalize text-tiny"
											customDropdownClass="w-full"
											>
										<template #toggle-button>
											{{ platform.configurableMetadata.privacyStatus || selectedPrivacyStatus }}
											<icon-base
												class="ml-auto">
												<icon-chevron-down />
											</icon-base>
										</template>
										<template #menu-items>
											<drop-down-menu-item customClasses="max-w-full w-full h-auto flex flex-col text-wrap text-left items-start px-3 py-2 text-tiny hover:bg-surface-4" @click="onPrivacySettingsChanged('public', platform)">
												Public
											</drop-down-menu-item>
											<hr>
											<drop-down-menu-item customClasses="max-w-full w-full h-auto flex flex-col text-wrap text-left items-start px-3 py-2 text-tiny hover:bg-surface-4" @click="onPrivacySettingsChanged('unlisted', platform)">
												Unlisted
											</drop-down-menu-item>
											<hr>
											<drop-down-menu-item customClasses="max-w-full w-full h-auto flex flex-col text-wrap text-left items-start px-3 py-2 text-tiny hover:bg-surface-4" @click="onPrivacySettingsChanged('private', platform)">
												Private
											</drop-down-menu-item>
										</template>
									</drop-down-menu>

								</div>

								<div v-if="canConfigureMetadata('game')" class="field-container mt-4">
									<FormInput label="Category" v-model="platform.configurableMetadata.game" @input="onChangeGameName" placeholder="Enter a category or game" class="mb-2" />

									<b-dropdown id="twitch-game-dropdown" variant="dark-3" class="region-dropdown w-100 mb-2"
										menu-class="dropdown-menu_md test w-100 mt-0" size="md" no-caret toggle-class="twitch-dropdown-toggle"
										ref="twitch-dropdown">
										<b-dropdown-item v-for="category in twitchCategories" :key="category.id" link-class="d-block"
											class="page-item" @click="onSelectTwitchCategory(category)">
											<div class="main text-s-m text-dark-9 text-500">
												{{ category.name }}
											</div>
										</b-dropdown-item>
									</b-dropdown>

								</div>

								<div v-if="hasMetaProp('persistent')" class="field-container mt-4">
									<div class="label">
										{{ getMetadataPropValue('persistent', true).label }}
									</div>

									<i v-if="platform.configurableMetadata.persistent" class="fas fa-toggle-on toggle-control enabled"
										@click="setMetadataPropValue('persistent', false)" />

									<i v-else class="fas fa-toggle-off toggle-control" @click="setMetadataPropValue('persistent', true)" />
								</div>
							</div>
							<form-button class="w-full justify-center" disabled v-if="processing"> 
								<Spinner text="Creating..." classes="text-dark-8" spinner-color="var(--c-dark-8)" spinner-size="15px" />
							</form-button>
							<div v-if="!processing && (!serviceLinkProcessing || configRequired)">
								<form-button v-if="canSave" class="w-full justify-center mb-2" @click="onSavePlatform" :disabled="!isRtmpPassValid || ((customSrtPlatformErrors.host.length + customSrtPlatformErrors.latency.length + customSrtPlatformErrors.port.length + customSrtPlatformErrors.server.length + customSrtPlatformErrors.streamId.length + customSrtPlatformErrors.streamKey.length) > 0)"> 
									Create Platform
								</form-button>
								<form-button type="secondary" class="w-full justify-center" @click="unselectPlatform"> 
									Cancel
								</form-button>
							</div>
						</div>
					</b-col>
				</b-row>
			</section>
			<div>
				<div class="second-modal">
					<div class="platform-info">
						<div v-if="platform.name" class="platform-icon">
							<img :src="platform.icon">
						</div>
						<div v-show="customPlatform" class="platform-name">
							Custom Encoder
						</div>
					</div>

					<!-- available platform list -->
					<section :class="{ collapsed: stage >= 1 }" class="platforms">


					</section>

					<!-- platform list -->
					<section v-if="stage === 1" class="second-modal">


						<!-- error placeholder -->

						<!-- form -->
						<!-- <div v-if="platform.canLinkService" -->
						<!-- <div v-if="shouldShowServiceLinkingPrompt()" -->

						<br>
					</section>
				</div>
			</div>
		</b-modal>

		<alert-modal
			:description="`Please add Castr application to your Facebook Group '${selectedSubChannel && selectedSubChannel.name}' to connect with Castr`"
			modal-id="modal-facebook-groups-guide"
			message="Please add Castr app to your Facebook Group (Settings -> Manage Advanced Settings -> Apps) or check your permission to stream to Group on Facebook. If you still encounter problem, please contact our support team."
			ok-text="Close" ok-href="https://web.facebook.com/help/261149227954100?_rdc=1&_rdr" />

		<confirm-modal modal-id="modal-custom-server-premium-feat"
			message="This feature is only available in our paid subscriptions" ok-text="Upgrade now" cancel-text="No thanks"
			@modal-confirm="navigatePaymentsPage" />
	</div>
</template>

<script>
import _ from 'lodash';
import { v4 } from "uuid"
import Spinner from "@/components/ui/Spinner.vue";
import StreamService from '@/services/StreamService';
import IntegrationService from '@/services/IntegrationService';
import AlertModal from '@/components/modals/AlertModal.vue';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import FormButton from '../../components/Atoms/FormButton.vue';
import FormInput from '../../components/Atoms/FormInput.vue';
import IconBase from '@/components/icon/IconBase.vue'
import IconClose from '@/components/icon/IconClose.vue'
import DropDownMenu from '../../components/Atoms/DropDownMenu.vue';
import DropDownMenuItem from '../../components/Atoms/DropDownMenuItem.vue';

import utils from '@/utils';

export default {
	name: 'AddPlatformModal',
	components: {
		AlertModal,
		ConfirmModal,
		Spinner,
		FormButton,
		FormInput,
		IconClose,
		IconBase,
		DropDownMenu,
		DropDownMenuItem,
	},
	props: {
		stream: {
			type: Object,
			required: true,
			validator(v) {
				return Object.prototype.hasOwnProperty.call(v, '_id');
			}
		},
		platformDeleted: Boolean,
		platformUsageData: Object
	},
	data() {
		return {
			// processingSec: 40,
			selectedPrivacyStatus: 'public',
			oauthProcessing: false,
			chosenServer: null,
			stage: 0,
			processing: false,
			error: null,
			serviceLinkError: false,
			serviceLinkConflict: false,
			platformServerInputMode: null,
			configRequired: false,
			linkedServiceCreds: null,
			serviceLinkProcessing: false,
			platform: { enabled: false, configurableMetadata: {} },
			selectedSubChannel: null,
			customPlatform: false,
			// platformTemplates: Platforms,
			platformTemplates: [],
			platformListProcessing: false,
			serviceResponseRecieved: false,
			formErrors: { server: false, streamKey: false, host: false, port: false, streamId: false },
			oauthConnectId: null,
			isAuthRequired: false,
			rtmpAuthUsername: '',
			rtmpAuthPassword: '',
			streamCreateDropdownActive: false,
			maxLengthTitle: 1000,
			maxLengthDescription: 5000,
			showTitleLimitTracking: false,
			isSchedulerInfiniteLoop: false,
			platformUsage: null,
			customMode: 'RTMP',
			customSrtPlatform: {
				server: '',
				host: '',
				port: '',
				streamId: '',
				latency: 120,
				passphrase: ''
			},
			customSrtPlatformErrors: {
				server: '',
				host: '',
				port: '',
				streamId: '',
				streamKey: '',
				latency: '',
				host: '',
				passphrase: ''
			},
			platformDisable: false,
			twitchCategories: [],
			isRtmpPassValid: true,
		};
	},
	computed: {
		user() {
			return this.$store.state.User;
		},
		canSave() {
			const validStage = this.stage > 0;
			return validStage;
		},
		hasPremiumSubscription() {
			const userSubs = this.$store.state.User.subscriptions.map(sub => _.assign({ category: 'restream' }, sub));
			const subscription = userSubs.find(sub => sub.category && sub.category.includes(this.stream.type));
			let isPremiumSubs = false;
			userSubs.forEach((item) => {
				if (item.category.includes(this.stream.type) && item.package && item.package.definition.allowLinkingFbPage !== false) {
					isPremiumSubs = true;
				}
			})
			// And the current sub is not Simulcast yearly & Broadcast trial 7 days (ID 253, 171, 250)
			// ref: https://docs.google.com/spreadsheets/d/1smxssUcDSyK-AM1pzIFHxa5vgXNsnMDAaMbWqrRW6Pc
			return isPremiumSubs && subscription.package._id !== '5fffc31103afd67aa9831cc6' && subscription.package._id !== '5ccc3a3c588ccab4bdd556e7' &&
				subscription.package._id !== '5fffc14a03afd67aa9831cc3' && subscription.package._id !== '5ccc2ee6588ccab4bdd556df';
		},
		subscriptions() {
			return this.$store.state.User.subscriptions.map(sub => _.assign({ category: 'restream' }, sub));
		},
		isBroadcastSubscription() {
			// Check if the user's package is 'Simulcast monthly/yearly'
			const simulcastMonthlyId = '5fffc14a03afd67aa9831cc3'
			const simulcastYearlyId = '5fffc31103afd67aa9831cc6'
			const broadcast7DaysTrial = '5ccc3a3c588ccab4bdd556e7'
			let isBroadcastSubscription = false
			this.$store.state.User.subscriptions.forEach(sub => {
				if (sub.enabled === true && (
					sub.package._id === simulcastMonthlyId
					|| sub.package._id === simulcastYearlyId
					|| sub.package._id === broadcast7DaysTrial
				) && sub.package.category === this.stream.type) {
					isBroadcastSubscription = true
				}
			});
			return isBroadcastSubscription
		}
	},
	watch: {
		isAuthRequired: function (isRequired) {
			if (!isRequired) {
				this.platform.server = this.platform.server.replace(
					/:\/\/.*?:.*?@/,
					'://'
				);
			} else {
				this.rtmpAuthUsername = '';
				this.rtmpAuthPassword = '';
			}
		},
		platformDeleted: function () {
			this.fetchPlatformUsage();
		},
		platformUsageData: function () {
			this.platformUsage = this.platformUsageData;
		},
		rtmpAuthUsername: function (val) {
			if (this.platform.server) {
				this.platform.server = this.platform.server.replace(
					/:\/\/.*?:.*?@/,
					'://'
				);
				if (val && this.rtmpAuthPassword) {
					this.platform.server = this.platform.server.replace(
						'://',
						'://' +
						encodeURIComponent(val) +
						':' +
						encodeURIComponent(this.rtmpAuthPassword) +
						'@'
					);
				}
			}
		},
		rtmpAuthPassword: function (val) {
			if (this.platform.server) {
				this.platform.server = this.platform.server.replace(
					/:\/\/.*?:.*?@/,
					'://'
				);
				if (this.rtmpAuthUsername && val) {
					this.platform.server = this.platform.server.replace(
						'://',
						'://' +
						encodeURIComponent(this.rtmpAuthUsername) +
						':' +
						encodeURIComponent(val) +
						'@'
					);
				}
			}
		}
	},
	async mounted() {
		FormInput.compatConfig = { MODE: 3 }
		this.$refs.modalAddPlatform.$on('hide', this.onDismiss.bind(this));
		this.$refs.modalAddPlatform.$on('show', this.onInit.bind(this));
		this.initPlatformTemplates();
	},
	methods: {
		onPrivacySettingsChanged(status, platform) {
			this.selectedPrivacyStatus = status;
			platform.configurableMetadata.privacyStatus = status;
			if(_.isArray(this.$refs.youtubePrivacyDropdownInDialog)) {
				this.$refs.youtubePrivacyDropdownInDialog.forEach(x => x.toggleDropdown())
			} else {
				this.$refs.youtubePrivacyDropdownInDialog.toggleDropdown();
			}
		},
		onChangeGameName: _.debounce(async function (name) {
			if (!this.linkedServiceCreds) return;
			this.twitchCategories = await IntegrationService.getTwitchCategories(this.linkedServiceCreds, name);
			if (this.twitchCategories?.length) this.$refs['twitch-dropdown'].show();
		}, 250),
		onSelectTwitchCategory(category) {
			if (!this.linkedServiceCreds) return;
			this.platform.configurableMetadata.game_id = category.id;
			this.platform.configurableMetadata.game = category.name;
			this.$refs['twitch-dropdown'].hide();
			this.$forceUpdate();
		},
		onCustomModeChanged(mode) {
			this.customMode = mode
		},
		onInit() { },
		async initPlatformTemplates() {
			this.platformListProcessing = true;
			this.platformTemplates = await IntegrationService.getPublishPlatformList();
			this.platformListProcessing = false;
		},
		getStreamtype() {
			const category = this.stream.type;
			let CategoryName = null;
			if (category == 'live') {
				CategoryName = 'All in One Streams'
			} else if (category == 'scheduled') {
				CategoryName = 'Pre-recorded Streams'
			} else if (category == 'restream') {
				CategoryName = 'Multistreams'
			}
			return CategoryName;
		},
		navigatePaymentsPage() {
			const category = this.stream.type;
			window.location.href = `/app/subscribe?category=${category}`;
		},
		async fetchPlatformUsage() {
			const platformUsage = await StreamService.getPlatformUsage(this.stream.type);
			if (platformUsage) this.platformUsage = platformUsage
		},
		onFacebookPopup(e) {
			e.preventDefault();
			this.$root.$emit(
				'bv::show::modal',
				'modal-facebook-integration-prompt'
			);
		},
		stepBack() {
			this.stage--;

			this.clearErrors();
			this.resetPlatform();
		},
		focusServerKeySegment(event) {
			const soruceElement = event.target || event.srcElement;
			if (soruceElement instanceof HTMLInputElement) return;

			this.$refs.segment[0].focus();
		},
		computePlatformServerFromSegments() {
			const { platform } = this;
			console.log(platform);
			const { serverKeySegments, serverKeySegmentValues } = platform;
			const inputSegments = _.filter(serverKeySegments, { input: true });
			const validSegmentValues = _.compact(serverKeySegmentValues);

			if (_.size(inputSegments) !== _.size(validSegmentValues)) {
				this.platform.server = null;
				return;
			}

			let serverAddr = '';
			_.each(platform.serverKeySegments, (segment, index) => {
				if (segment.exclude) return;

				if (segment.input) {
					serverAddr += serverKeySegmentValues[index];
				} else {
					serverAddr += segment.text || segment;
				}
			});

			this.platform.server = serverAddr;
		},
		async selectPlatform(platform) {
			this.clearErrors();

			if (this.platform.name || this.customPlatform) {
				this.unselectPlatform();
				setTimeout(() => this.selectPlatform(platform), 250);
				return;
			}
			this.serviceLinkProcessing = false;
			this.selectedSubChannel = null;
			this.serviceResponseRecieved = false;
			this.customPlatform = !platform;
			this.platform = _.assign({}, this.platform, _.cloneDeep(platform));
			this.platformServerInputMode = this.platform.serverKeySegments && Object.keys(this.platform.serverKeySegments).length
				? 'chunks'
				: this.platform.servers
					? 'select'
					: 'input';

			if (this.canConfigureMetadata()) {
				this.platform.configurableMetadata = {
					...this.platform.configurableMetadata,
					title: this.getMetadataPropValue('title'),
					description: this.getMetadataPropValue('description'),
					persistent: false
				};
			}

			let preselectedServer = this.platform.servers && this.platform.servers[0];
			if (preselectedServer) {
				preselectedServer = preselectedServer.value || preselectedServer;
				this.platform.server = preselectedServer;
			}

			let canConfiguredOAuth = this.platform.canLinkService;
			if (canConfiguredOAuth && this.platform.oauthCheckRequired) {
				canConfiguredOAuth = false;
				const usersubs = this.subscriptions;
				const basesub = _.find(usersubs, { category: this.stream.type });
				if (basesub) {
					let oauthIntegrationsRules = basesub.oauthIntegrations;
					// if (!oauthIntegrationsRules && basesub.definitionOverride) {
					//   oauthIntegrationsRules = basesub.definitionOverride.oauthIntegrations
					// }

					if (!oauthIntegrationsRules) {
						// extract from sub def overrides
						if (basesub.definitionOverride) {
							oauthIntegrationsRules = basesub.definitionOverride.oauthIntegrations;
						}

						// extract from sub pack def
						if (!oauthIntegrationsRules) {
							oauthIntegrationsRules = basesub.package.definition.oauthIntegrations;
						}
					}

					const canlinkService = _.find(oauthIntegrationsRules, { template: this.platform.slug || this.platform.name, enabled: true });
					canConfiguredOAuth = !!canlinkService;
				}

				// We allow scheduled stream with datetime mode connect to Facebook via API
				if (this.stream.type === 'scheduled') {
					canConfiguredOAuth = true;
					const schedulerConfig = await StreamService.getStreamScheduleSettings(this.stream._id) || {};
					if (schedulerConfig.mode === 'loop') {
						this.isSchedulerInfiniteLoop = true;
					} else this.isSchedulerInfiniteLoop = false;
				}
			}

			// this.configRequired = !this.platform.canLinkService
			this.configRequired = !canConfiguredOAuth;

			// move to next step
			this.stage = 1;
		},
		unselectPlatform() {
			this.platform = {
				enabled: false,
				configurableMetadata: {}
			};

			this.rtmpAuthUsername = '';
			this.rtmpAuthPassword = '';
			this.customPlatform = false;
			this.configRequired = false;
			this.stage = 0;
			this.linkedServiceCreds = null;
			this.selectedSubChannel = null;
		},
		onInputChange(prop) {
			this.formErrors[prop] = false;


			if (prop === 'port' && this.customSrtPlatform.port) {
				const portNum = parseInt(this.customSrtPlatform.port)
				if (!portNum || /\D/.test(this.customSrtPlatform.port)) {
					this.customSrtPlatformErrors.port = 'Port must be a number'
					// replace value
					this.customSrtPlatform.port = ''
				}
				else if (portNum > 65535) {
					this.customSrtPlatformErrors.port = 'Port must be equal to or below 65535'
				} else {
					this.customSrtPlatformErrors.port = ''
				}
			} else {
				this.customSrtPlatformErrors.port = ''
			}

			if (prop === 'latency' && this.customSrtPlatform.latency) {
				const portNum = parseInt(this.customSrtPlatform.latency)
				if (!portNum || /\D/.test(this.customSrtPlatform.latency)) {
					this.customSrtPlatformErrors.latency = 'Latency must be a number'
					// replace value
					this.customSrtPlatform.latency = ''
				} else {
					this.customSrtPlatformErrors.latency = ''
				}
			} else {
				this.customSrtPlatformErrors.latency = ''
			}

			// remove unnecessary key chars
			if (prop === 'streamKey') {
				if (/\^/.test(this.platform.streamKey)) {
					this.customSrtPlatformErrors.streamKey = 'invalid streaming key'
					// replace value
					// this.customSrtPlatform.host = ''
				} else {
					this.customSrtPlatformErrors.streamKey = ''
				}
			}
			if (prop === 'streamKey') {
				setTimeout(() => {
					this.platform[prop] = utils.resolveStreamKey(
						this.platform[prop]
					);
				});
			}
			if (prop === 'host') {
				this.customSrtPlatform.host = this.customSrtPlatform.host.replace(/\s/g, '');
				if (/\^/.test(this.customSrtPlatform.host)) {
					this.customSrtPlatformErrors.host = 'invalid host format'
					// replace value
					// this.customSrtPlatform.host = ''
				} else {
					this.customSrtPlatformErrors.host = ''
				}
			}
			if (prop === 'streamId') {
				this.customSrtPlatform.streamId = this.customSrtPlatform.streamId.replace(/\s/g, '');
				if (/\^/.test(this.customSrtPlatform.streamId)) {
					this.customSrtPlatformErrors.streamId = 'invalid streamId format'
					// replace value
					// this.customSrtPlatform.host = ''
				} else {
					this.customSrtPlatformErrors.streamId = ''
				}
			}
			// setTimeout(() => {
			// 	if (
			// 		this.platform.server &&
			//    !this.platform.server.match(/^[a-z]+:\/\//i)
			// 	) {
			// 		this.platform.server = 'rtmp://' + this.platform.server;
			// 	}
			// });
			if (prop === 'server') {
				this.platform.server = this.platform?.server?.replace(/\s/g, '');
				if (/\^/.test(this.platform.server)) {
					this.customSrtPlatformErrors.server = 'invalid destination ingest address'
					// replace value
					// this.customSrtPlatform.host = ''
				} else {
					this.customSrtPlatformErrors.server = ''
				}
			}
			setTimeout(() => {
				if (prop === 'server' && this.platform.server) {
					let userAuthMatch;

					if (
						(userAuthMatch = this.platform.server.match(
							/:\/\/(.*?):(.*?)@/
						))
					) {
						this.isAuthRequired = true;

						setTimeout(() => {
							this.rtmpAuthUsername = decodeURIComponent(
								userAuthMatch[1]
							);
							this.rtmpAuthPassword = decodeURIComponent(
								userAuthMatch[2]
							);
						}, 100);
					}
				}
			}, 100);
		},
		selectServer(server) {
			this.chosenServer = server.text
			this.platform.server = server.value;

		},
		shouldConfigureServer() {
			const haveConfigured =
				this.platform.server && this.platformServerInputMode === 'auto';


			const result = !haveConfigured &&
				(this.customPlatform || this.platform.customServer || this.hasMultiplePlatformServers(this.platform));
			if (result) {
				if (this.platform.name === 'facebook live' && !this.platform.server) {
					this.platform.server = 'rtmps://live-api-s.facebook.com:443/rtmp'
				}
				if (this.platform.name === 'youtube events' && !this.platform.server) {
					this.platform.server = 'rtmp://a.rtmp.youtube.com/live2'
				}
				if ((this.platform.name || '').toLowerCase() === 'vimm.tv' && !this.platform.server) {
					this.platform.server = 'rtmp://rtmp.livepeer.com/live'
				}
			}
			return result;
		},
		checkServerInputMode(matchInputMode) {
			return (
				this.platformServerInputMode &&
				this.platformServerInputMode === matchInputMode
			);
		},
		shouldShowServiceLinkingPrompt() {
			return !this.configRequired;
			// return this.platform.canLinkService && !this.configRequired
			// return this.platform.canLinkService;
			// const bool = this.platform.canLinkService && !this.platform.ignoreServiceLinking
			// console.log('shouldShowServiceLinkingPrompt', bool)
			// return bool
		},
		ignoreServiceLinking() {
			if (this.platform.customServerPremiumFeat) {
				const baseSub = this.subscriptions.find(sub => sub.category && sub.category.includes(this.stream.type));
				const isTrialSub = /trial/gi.test(baseSub.package.name || '');
				if (isTrialSub) {
					this.$root.$emit(
						'bv::show::modal',
						'modal-custom-server-premium-feat'
					);
					return;
				}
			}

			this.configRequired = true;
			this.platform.customServer = true;
			// this.platform.canLinkService = false;
			// this.platform.ignoreServiceLinking=true
			// console.log(this.platform);
		},
		hasMultiplePlatformServers(platform) {
			return (
				_.size(platform.servers) > 1 || _.size(platform.serverKeySegments)
			);
		},
		getServiceOAuthUrl() {
			if (this.isSchedulerInfiniteLoop) return;
			const oauthFactoryName =
				this.platform.oauthSlug || this.platform.slug || this.platform.name;
			const pathname = `integrations/${oauthFactoryName}/oauth`;
			const connectId = v4()
			if (!this.oauthConnectId) this.oauthConnectId = connectId;

			const searchParams = `redirect=1&user=${this.user._id || this.user.id}&stream=${this.stream._id
				}&connectId=${this.oauthConnectId}`;
			let routeUrl = `${process.env.VUE_APP_APP_API_BASE}/${pathname}?${searchParams}`;
			console.log(routeUrl);
			if (window.todesktop && (oauthFactoryName == 'facebook')) {
				window.todesktop.contents.openUrlInBrowser(routeUrl);
			} else {
				window.open(routeUrl, '_blank');
			}

		},
		cancelServiceLinking() {
			this.serviceLinkError = false;
			this.serviceLinkConflict = false;
			this.serviceLinkProcessing = false;
		},
		async onServiceAuthURLTap() {
			// Check if there is any available platform to add
			try {
				const isAvailableSlot = await StreamService.addStreamPlatform(this.stream._id, {
					template: this.customPlatform ? 'custom' : this.platform.name,
					server: 'test',
					key: 'test',
					enabled: false,
					preChecking: true
				})
			} catch (error) {
				console.error(error.stack);
				if (error.message === 'Please upgrade your subscription to add more streams and platforms.') {
					return this.error = error;
				}
			}

			this.serviceLinkConflict = false;
			this.serviceLinkProcessing = true;

			// const serviceName = this.platform.name;
			const connectId = this.oauthConnectId;
			this.oauthConnectId = null;

			// const ackTag = 'oauth-link'
			// Vue.appEvents.emit('ack.listen', ackTag, connectId)
			// const subkey = [ackTag, connectId].join('.')

			// #DISABLED FOR DEBUG
			// Vue.appEvents.on(subkey, this.onServiceAuthResponse)
			this.oauthProcessing = true;
			this.listenAckEventResponse(connectId, this.onServiceAuthResponse);
			// #ENABLED FOR DEBUG
			// this.onServiceAuthResponse({linkedMeta: "5dc40186ed240b447c1d911b"})
		},
		async listenAckEventResponse(key, callback) {
			if (this.oauthProcessing && !this.serviceLinkProcessing) return;
			const ackRes = await IntegrationService.getAckByKey(key);
			// console.log('ackRes', ackRes)
			if (ackRes && ackRes.success) {
				callback(ackRes.data);
				this.oauthProcessing = false;
			} else {
				setTimeout(() => {
					this.listenAckEventResponse(key, callback);
				}, 4000);
			}
		},
		hasMetaProp(propname) {
			if (
				!this.linkedServiceCreds ||
				!this.platform.serviceAuthorization ||
				!propname
			)
				return;

			const { metadata } = this.platform.serviceAuthorization;

			// let canConfigure = false
			const { fields } = metadata;

			// perform multi key matching `OR`
			if (!_.isArray(propname)) {
				propname = [propname];
			}

			let keyFound = false;
			_.each(propname, key => {
				// check for property existences
				if (keyFound) return;
				const field = _.find(fields, { key });
				keyFound = !!field;
			});

			return keyFound;
		},
		canConfigureMetadata(propname) {
			if (
				!this.linkedServiceCreds ||
				!this.platform.serviceAuthorization ||
				(this.platform.serviceAuthorization &&
					this.platform.serviceAuthorization.subChannelBasedMetadata &&
					!this.platform.subChannel &&
					propname)
			)
				return;

			const { metadata } = this.platform.serviceAuthorization;
			if (propname === undefined) {
				return !!metadata;
			}

			let canConfigure = false;
			const { fields } = metadata;

			// check for property being disabled
			const field = _.find(fields, { key: propname });
			canConfigure = field && !field.disabled;
			return canConfigure;
		},
		getMetadataPropValue(propname, getDefinition) {
			const { fields } = this.platform.serviceAuthorization.metadata;
			const field = _.find(fields, { key: propname });
			return getDefinition ? field : field && field.value;
		},
		setMetadataPropValue(propname, value) {
			this.platform.configurableMetadata[propname] = value;
		},
		showFacebookGroupsGuide() {
			this.$root.$emit('bv::show::modal', 'modal-facebook-groups-guide');
		},
		async setSubChannels(oauthMetaId) {
			this.platform.subChannelList = await IntegrationService.getServiceSubChannels(oauthMetaId);
			if (this.platform.subChannelList.length) {
				if (this.platform.serviceAuthorization && this.platform.serviceAuthorization.autoSelectDefaultSubChannel) {
					this.changeSubChannelSelection(this.platform.subChannelList[0]);
				}
			}
		},
		onSubchannelListToggle(state) {
			this.streamCreateDropdownActive = state;
		},
		isSubChannelDisabled(subChannelItem) {
			let isDisabled = false;
			if (!this.hasPremiumSubscription && /facebook/g.test(this.platform.name)) {
				isDisabled = subChannelItem.id !== 0;
			}
			return isDisabled;
		},
		changeSubChannelSelection(subChannelItem) {
			if (this.isSubChannelDisabled(subChannelItem)) return;

			this.selectedSubChannel = subChannelItem;
			const subchannelSlug = (subChannelItem.type || '-') + '@' + subChannelItem.id;
			this.platform.subChannel = subchannelSlug;
			this.onSubChannelChange();
		},
		async onSubChannelChange() {
			let selectedSubChannel = this.platform.subChannel;
			if (selectedSubChannel === 'new') return;
			const subChannelId = selectedSubChannel.split('@')[1];
			selectedSubChannel = this.platform.subChannelList.find(({ id }) => id === subChannelId);

			if (this.platform.serviceAuthorization && this.platform.serviceAuthorization.subChannelBasedMetadata) {
				if (selectedSubChannel) {
					if (selectedSubChannel.metadata) {
						const chMeta = selectedSubChannel.metadata;
						this.platform.configurableMetadata = {
							...this.platform.configurableMetadata,
							title: chMeta.title,
							description: chMeta.description
						};
					}
				}
			}
		},
		async onServiceAuthResponse(response) {
			if (this.serviceResponseRecieved) return;
			this.serviceResponseRecieved = true;
			if (!response || response.error) {
				this.serviceLinkError = true;
				return;
			}
			const oauthMetaId = response.linkedMeta;
			// acknowledge UI, authorization was successful
			this.linkedServiceCreds = oauthMetaId;

			// check for linking conflicts
			let linkResult;
			try {
				linkResult = await IntegrationService.checkIntegrationConflict(this.stream._id, oauthMetaId);
			} catch (err) {
				console.log('integration-conflict-check-error', err);
				window.alert('could not perform integration duplication check');
			}

			if (!linkResult || linkResult.linked) {
				// conflicts are there
				this.serviceLinkError = true;
				this.serviceLinkConflict = true;
				this.linkedServiceCreds = null;
				return;
			}

			// check if serice supports metadata integration
			const { serviceAuthorization } = this.platform;
			if (serviceAuthorization && serviceAuthorization.subChannelRequired) {
				await this.setSubChannels(oauthMetaId);
			}

			let metaOverrides = {};
			const ingestConfParams = {};

			if (serviceAuthorization && serviceAuthorization.subChannelBasedMetadata) {
				// this.configRequired = true
				// this.platformServerInputMode = 'auto'
				metaOverrides = {
					title: '',
					description: '',
					game: ''
				};
				ingestConfParams.subChannelBasedMetadata = true;
			}

			const ingest = await this.setServiceIngest(oauthMetaId, ingestConfParams);
			if (!ingest) return;
			let configRequired = false;
			if (ingest.server) {
				this.platformServerInputMode = 'auto';
			} else {
				configRequired = true;
			}

			if (serviceAuthorization && serviceAuthorization.metadata) {
				configRequired = true;
				await this.setupServiceMetadata(oauthMetaId, metaOverrides);
			}

			this.configRequired = configRequired;
			if (configRequired) return;

			this.onSavePlatform();
		},
		async setServiceIngest(oauthMetaId, params) {
			let ingest;
			try {
				ingest = await IntegrationService.getServiceIngest(
					oauthMetaId,
					params
				);
			} catch (e) {
				this.serviceLinkError = true;
				return;
			}

			if (!ingest) {
				this.serviceLinkError = true;
				return;
			}

			if (ingest.streamCreationRequired) {
				this.platform.streamCreationRequired = true;
				ingest._id = oauthMetaId;
				ingest.key = '#streamkey';
				ingest.server = '#serveraddr';
			}

			this.platform.enabled = true;
			this.platform.streamKey = ingest.key;
			this.platform.server = ingest.server;
			this.linkedServiceCreds = ingest._id;

			return ingest;
		},
		async setupServiceMetadata(oauthMetaId, metaOverrides = {}) {
			// get existing metadata details
			try {
				const metaprops = {
					title: this.getMetadataPropValue('title'),
					description: this.getMetadataPropValue('description'),
					game: this.getMetadataPropValue('game')
				};

				for (const prop in metaOverrides) {
					if (Object.prototype.hasOwnProperty.call(metaOverrides, prop)) {
						metaprops[prop] = metaOverrides[prop];
					}
				}

				if (this.platform.streamCreationRequired) {
					this.platform.configurableMetadata = _.assign(
						{},
						this.platform.configurableMetadata,
						{
							title: metaprops.title,
							description: metaprops.description,
							game: metaprops.game,
							persistent: false
						}
					);
				} else {
					let streamMeta = await IntegrationService.getIntegrationMetadata(oauthMetaId);
					streamMeta.persistent = false;

					streamMeta = Object.assign({}, streamMeta, metaOverrides);
					this.platform.configurableMetadata = streamMeta;
				}

				// check for fixed/disabled fields
				['title', 'description', 'game'].forEach(prop => {
					const metaField = this.getMetadataPropValue(prop, true);
					const { disabled } = metaField || {};
					let { value: metavalue } = metaField || {};
					metavalue = prop in metaprops ? metaprops[prop] : metavalue;
					if (disabled) this.platform.configurableMetadata[prop] = metavalue;
				});
			} catch (e) {
				console.log(e);
			}

			// Set up platform title limit for Youtube event
			if (this.platform.name === 'youtube events') {
				if (this.platform.configurableMetadata && _.isString(this.platform.configurableMetadata.title)) {
					this.showTitleLimitTracking = true
				}
				this.maxLengthTitle = 100
			} else {
				this.showTitleLimitTracking = false
				this.maxLengthTitle = 1000
			}
		},
		isServiceAlreadyLinked() {
			// const currentTemplate = this.platform.name
			// const linked = _.find(
			//   this.stream.platforms,
			//   platform =>
			//     platform.template === currentTemplate && platform.linkedServiceCreds
			// )
			// return !!linked;
			return false;
		},
		async onSavePlatform() {
			// this.processingSec = 40
			// let intervalctrl = setInterval(() => {
			//   if (!this.processingSec) {
			//     clearInterval(intervalctrl)
			//     return
			//   }

			//   this.processingSec -= 1
			// }, 1000)
			this.checkPassword()
			this.error = null;
			if (!this.validateForm() && !this.platform.streamCreationRequired || !this.isRtmpPassValid) {
				// window.alert('warning: form not completely filled')
				return;
			}

			if (
				this.linkedServiceCreds &&
				this.platform.serviceAuthorization &&
				this.platform.serviceAuthorization.subChannelRequired &&
				!this.platform.subChannel
			) {
				let channelType = 'sub channel';
				if (this.platform.template === 'youtube') {
					channelType = 'event';
				}

				window.alert(`warning: Please select ${channelType}`);
				return;
			}

			this.processing = true;
			let payload;

			if (this.customMode === 'SRT' && this.customPlatform) {
				payload = {
					enabled: this.platform.enabled,
					server: this.modifySrtUrl(this.customSrtPlatform.host),
					key: this.customSrtPlatform.streamId,
					template: 'custom',
					mode: 'srt',
					port: this.customSrtPlatform.port,
					latency: this.customSrtPlatform.latency,
					passphrase: this.customSrtPlatform.passphrase
				};
			} else {
				// let serverAddr = this.platform.server
				// serverAddr = _.replace(serverAddr, /^rtmps/gi, 'rtmp')
				// serverAddr = _.replace(serverAddr, /\:443/gi, ':80')
				let serverAddr = this.platform.server;
				serverAddr = utils.resolveURL(serverAddr, true);

				let streamKey = this.platform.streamKey;
				streamKey = utils.resolveStreamKey(streamKey);

				payload = {
					enabled: this.platform.enabled,
					server: serverAddr,
					key: streamKey,
					template: this.customPlatform ? 'custom' : this.platform.name
				};
			}

			// payload.serviceMeta = {}
			if (this.canConfigureMetadata()) {
				const {
					title,
					description,
					privacyStatus,
					game,
					game_id,
					persistent
				} = this.platform.configurableMetadata;
				const metaUpdates = {};
				if (title) {
					metaUpdates.title = title;
				}
				if (description) {
					metaUpdates.description = description;
				}
				if (game) {
					metaUpdates.game = game;
				}
				if (game_id) {
					metaUpdates.game_id = game_id;
				}
				if (persistent) {
					metaUpdates.persistent = persistent;
				}
				if(privacyStatus) {
					metaUpdates.privacyStatus = privacyStatus;
				}
				payload.serviceMeta = metaUpdates;
			}

			if (this.platform.streamCreationRequired) {
				let ingest;
				try {
					const metaprops = payload.serviceMeta;
					const params = {
						forceCreate: 1,
						streamTitle: metaprops.title,
						streamDescription: metaprops.description || metaprops.game,
						persistent: metaprops.persistent,
						title: metaprops.title,
						description: metaprops.description || metaprops.game,
						privacyStatus: metaprops.privacyStatus,
					};

					const subChannelId = this.platform.subChannel;
					if (subChannelId) {
						params.subChannel = subChannelId;
						payload.serviceMeta.subChannel = subChannelId;

						// let subChannelOriginalId = _.split(subChannelId, '@').pop()
						const [subChannelType, subChannelOriginalId] = _.split(subChannelId, '@');
						const subChannelObject = this.platform.subChannelList.find((c) => {
							const chId = String(c.id);
							return chId !== '0' && chId === subChannelOriginalId;
						});

						if (subChannelObject) {
							payload.serviceMeta.subChannelName = subChannelObject.name;

							// Add scheduleTime to prevent the BE override the current schedule time
							params.scheduleTime = subChannelObject.scheduleTime;
						}

						if (subChannelType === '-' && metaprops.title) {
							payload.serviceMeta.subChannelName = metaprops.title;
						}
					}

					// We use POST request here to avoid the case of the querystring too large, will be get the 414 error code from the back-end side
					ingest = await IntegrationService.getServiceIngest(
						this.linkedServiceCreds,
						params,
						'post'
					);
				} catch (e) {
					console.log(e);
					this.processing = false;

					const wasFacebookGroup =
						/facebook/g.test(this.platform.name || '') &&
						this.selectedSubChannel.type === 'group';
					if (wasFacebookGroup) {
						this.showFacebookGroupsGuide();
					} else {
						window.alert(
							'error: could not retreive ingest config, ' +
							(_.get(e, 'message') || e)
						);
					}
				}

				if (!ingest) {
					this.serviceLinkError = true;
					return;
				}

				this.linkedServiceCreds = ingest._id;
				payload.key = utils.resolveStreamKey(ingest.key, true);
				payload.server = utils.resolveURL(ingest.server, true);
				payload.ignoreServiceMetaUpdates = true;

				if (ingest.subChannelId) {
					payload.serviceMeta.subChannel = ingest.subChannelId;
				}
			}

			if (this.linkedServiceCreds) {
				payload.enabled = true;
				payload.linkedServiceCreds = this.linkedServiceCreds;
			}

			try {
				const platform = await StreamService.addStreamPlatform(
					this.stream._id,
					payload
				);
				this.$emit('platform-saved', platform);
				this.fetchPlatformUsage();
				setTimeout(() => this.dismiss(), 600);
			} catch (err) {
				this.error = err;
				this.processing = false;
				// check if subscripiton error
				if (err && _.indexOf(err.message, 'subscription') > -1) {
					this.error.subscription = true;
				}
			}
		},
		dismiss() {
			this.$refs.modalAddPlatform.hide();
			this.onDismiss();
		},
		modifySrtUrl(url) {
			if (url?.startsWith('srt://')) return url
			return 'srt://' + url
		},
		validateForm() {
			let props = ['server', 'streamKey'];
			let fields = this.platform

			if (this.customMode === 'SRT' && this.customPlatform) {
				props = ['host', 'port']
				fields = this.customSrtPlatform
			}

			let valids = 0;
			_.each(props, prop => {
				let val = fields[prop];
				if (prop === 'server') {
					let { valid } = utils.validateURL(val, { validatePathname: false });
					if(valid) {
						const platformName = this.platform?.name?.toLowerCase() || '';
						if(platformName.includes('tiktok')) {
							valid = val.includes('tiktokcdn');
						} else if(platformName.includes('instagram')) {
							valid = val.includes('fbcdn.net') || val.includes('instagram.com');
						}
					}
					if (!valid) val = null;
				}

				if (val) valids++;
				// else this.formErrors[prop] = true;

				this.formErrors[prop] = !val;
			});

			let srtValidation = true
			if (this.customMode === 'SRT') {
				if (this.customSrtPlatform.host.includes(`:${this.customSrtPlatform.port}`)) {
					this.customSrtPlatform.host = this.customSrtPlatform.host.replace(`:${this.customSrtPlatform.port}`, '')
				}

				srtValidation = srtValidation && !this.customSrtPlatformErrors.port
				srtValidation = srtValidation && !this.customSrtPlatformErrors.latency
			}

			return valids === props.length && srtValidation;
		},
		onDismiss() {
			// clear up cache
			this.resetPlatform();
			this.clearErrors();

			// lazy clear
			setTimeout(() => {
				this.stage = 0;
				this.processing = false;
			}, 1000);
		},
		clearErrors() {
			this.error = null;
			this.formErrors.server = false;
			this.formErrors.streamKey = false;
			this.formErrors.host = false;
			this.formErrors.port = false;
			this.formErrors.streamId = false;

			this.customSrtPlatformErrors = {
				host: '',
				latency: '',
				port: '',
				server: '',
				streamId: '',
				streamKey: '',
				passphrase: ''
			}
		},
		resetPlatform() {
			this.platform = { enabled: false };
			this.serviceLinkError = false;
			this.linkedServiceCreds = null;
			this.serviceLinkProcessing = false;
			this.rtmpAuthUsername = '';
			this.rtmpAuthPassword = '';

			this.customMode = 'RTMP'
			this.customSrtPlatform = {
				host: '',
				port: '',
				streamId: '',
				latency: 120,
				passphrase: ''
			}
		},
		checkPassword() {
			if (this.rtmpAuthPassword.includes('@')) {
				this.isRtmpPassValid = false
			} else this.isRtmpPassValid = true
		},
		isError(field) {
			return this.formErrors[field] || this.customSrtPlatformErrors.host > 0 ? true : false
		},
		errorText(field) {
			if (this.formErrors[field]) return 'Required field'
			if (this.customSrtPlatformErrors[field].length > 0) return this.customSrtPlatformErrors[field]
		}
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.custom-platform-type ul {
	background: var(--c-dark-3);
	border-radius: 6px;
	padding: 3px;
}

.custom-platform-type li {
	border-radius: 4px;
	display: inline-block;
	width: 100%;
	padding: 4px 5px;
	cursor: pointer;
}

.custom-platform-type li.active {
	background: var(--c-dark-5);
}

.facebooklive-disable-plat,
.youtubeevents-disable-plat {
	pointer-events: none;
	opacity: .4;
}

.error {
	color: #fff;
}

.platform-list {
	max-height: calc(100% - 200px);
	overflow-y: auto;
	overflow-x: hidden;
	position: absolute;
}

.platform-list>li:empty {
	display: none;
}

.platform-item {
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	border-radius: 6px;
	cursor: pointer;
}

.platform-item.active {
	background-color: var(--c-main-1);
}

.platform-icon img {
	max-height: 40px;
	object-fit: contain;
	margin-bottom: .5rem;
	width: 100%;
}

.platform-icon_secondary {
	max-height: 40px;
	object-fit: contain;
}

.second-modal {
	position: fixed;
	top: 0;
	background-color: var(--c-dark-2);
	margin: auto;
	width: 410px;
	height: 100%;
	-webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
	-moz-transition: opacity 0.3s linear, right 0.3s ease-out;
	-o-transition: opacity 0.3s linear, right 0.3s ease-out;
	transition: opacity 0.3s linear, left 0.3s ease-out;
	left: 0;
	z-index: -1;
	border-left: 1px solid var(--c-dark-3);
	border-right: 1px solid var(--c-dark-3);
}

.showform.second-modal {
	left: 510px;

	-webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
	-moz-transition: opacity 0.3s linear, right 0.3s ease-out;
	-o-transition: opacity 0.3s linear, right 0.3s ease-out;
	transition: opacity 0.3s linear, left 0.3s ease-out;
}

#service-subchannels-dropdown .hint-upgrade {
	display: none;
}

#service-subchannels-dropdown .disabled .hint-upgrade {
	display: block;
}

.lined {
	position: relative;
	display: flex;
	align-content: center;
	justify-content: center;
	white-space: nowrap;
}

.lined:before {
	content: '';
	position: relative;
	border-top: 1px solid var(--c-dark-3);
	width: 100%;
	top: 12px;
	margin-right: 10px;
}

.lined:after {
	content: '';
	position: relative;
	border-top: 1px solid var(--c-dark-3);
	width: 100%;
	top: 12px;
	margin-left: 10px;
}

:deep(* .dropdown-menu_md),
.tests {
	max-height: 300px;
	overflow-y: auto;
	max-width: 100%;
}

:deep(.page-item.dropdown-item) {
	white-space: normal;
}

.platform-label {
	text-transform: capitalize;
	text-align: center;
}

.add-platform-title {
	font-size: 20px;
}

.platform-item:hover {
	background-color: var(--c-dark-3);
}

.doc img {
	max-width: 16px;
	width: 100%;
	transform: translateY(-1px);
}

@media (max-width: 767px) {
	.showform.second-modal {
		top: 70px;
		left: 0;
		z-index: 1030;
		max-width: 100%;
	}
}
</style>